import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from '@dossierhq/design';
import { useMemo } from 'react';
export function ConnectionPagingButtons({ connection, pagingCount, onPagingChange }) {
    const handleStart = useMemo(() => {
        return connection?.pageInfo.hasPreviousPage
            ? () => onPagingChange({ first: pagingCount }, 'first-page')
            : undefined;
    }, [connection?.pageInfo.hasPreviousPage, onPagingChange, pagingCount]);
    // eslint-disable-next-line react-hooks/preserve-manual-memoization
    const handlePrevious = useMemo(() => {
        return connection?.pageInfo.hasPreviousPage
            ? () => onPagingChange({
                last: pagingCount,
                before: connection.pageInfo.startCursor,
            }, 'prev-page')
            : undefined;
    }, [
        connection?.pageInfo.hasPreviousPage,
        connection?.pageInfo.startCursor,
        onPagingChange,
        pagingCount,
    ]);
    // eslint-disable-next-line react-hooks/preserve-manual-memoization
    const handleNext = useMemo(() => {
        return connection?.pageInfo.hasNextPage
            ? () => onPagingChange({
                first: pagingCount,
                after: connection.pageInfo.endCursor,
            }, 'next-page')
            : undefined;
    }, [
        connection?.pageInfo.endCursor,
        connection?.pageInfo.hasNextPage,
        onPagingChange,
        pagingCount,
    ]);
    const handleEnd = useMemo(() => {
        return connection?.pageInfo.hasNextPage
            ? () => onPagingChange({ last: pagingCount }, 'last-page')
            : undefined;
    }, [connection?.pageInfo.hasNextPage, onPagingChange, pagingCount]);
    return (_jsxs(IconButton.Group, { condensed: true, skipBottomMargin: true, children: [_jsx(IconButton, { icon: "first", disabled: !handleStart, onMouseDown: handleStart }), _jsx(IconButton, { icon: "previous", disabled: !handlePrevious, onMouseDown: handlePrevious }), _jsx(IconButton, { icon: "next", disabled: !handleNext, onMouseDown: handleNext }), _jsx(IconButton, { icon: "last", disabled: !handleEnd, onMouseDown: handleEnd })] }));
}
//# sourceMappingURL=ConnectionPagingButtons.js.map